(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["am-product-rotation"] && !Shopify.designMode) return;
  try {
    
(() => {
  const rotations = new Map();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialize = () => {
    document.querySelectorAll('[data-am-product-rotation]').forEach((root) => {
      if (rotations.has(root)) return;
      const slider = root.querySelector('slideshow-component.resource-list__carousel');
      const toggle = root.querySelector('[data-am-rotation-toggle]');
      if (!slider || !toggle) return;
      const pauseLabel = toggle.textContent.trim();
      let paused = reducedMotion.matches;
      let visible = false;
      slider.setAttribute('infinite', '');
      const update = () => {
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.textContent = paused ? root.dataset.resumeLabel : pauseLabel;
      };
      const observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; }, { threshold: 0.15 });
      observer.observe(root);
      const click = () => { paused = !paused; update(); };
      toggle.addEventListener('click', click);
      const motion = () => { paused = reducedMotion.matches; update(); };
      reducedMotion.addEventListener('change', motion);
      const timer = window.setInterval(() => {
        if (paused || !visible || document.hidden || root.matches(':hover') || root.contains(document.activeElement)) return;
        const slides = slider.slides;
        if (!slides || slides.length < 2 || typeof slider.select !== 'function') return;
        const lastStart = Math.max(0, slides.length - Math.max(1, slider.visibleSlides?.length || 1));
        if (!lastStart) return;
        slider.select((slider.current || 0) >= lastStart ? 0 : (slider.current || 0) + 1);
      }, 15000);
      update();
      rotations.set(root, () => {
        window.clearInterval(timer);
        observer.disconnect();
        toggle.removeEventListener('click', click);
        reducedMotion.removeEventListener('change', motion);
      });
    });
  };
  const clean = () => {
    for (const [root, destroy] of rotations) {
      if (!root.isConnected) { destroy(); rotations.delete(root); }
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', () => queueMicrotask(clean));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
